module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/warning-ab2e968295b82abf2ec435dc24bd487d.svg";